function addHeaders(options = {}) {
  return {
    params: options,
  };
}

export default class API {
  async get(path, options = {}) {
    return this.$axios.get(path, addHeaders(options.params));
  }

  async post(path, options = {}) {
    return this.$axios.post(path, options.data, addHeaders(options.params));
  }

  async put(path, options = {}) {
    return this.$axios.put(path, options.data, addHeaders(options.params));
  }

  async del(path, options = {}) {
    return this.$axios.del(path, addHeaders(options.params));
  }
}
